export const LDFrontView = 31;
export const LDDefaultView = 1;
export const CylindoFrontView = 1;
export const CylindoDefaultView = 29;